// extracted by mini-css-extract-plugin
export var buttons = "_bt-0";
export var buttonsActive = "_bt-h";
export var cancelConfirm = "_bt-1";
export var closeButton = "_bt-2";
export var column = "_bt-3";
export var container = "_bt-4";
export var detailHeader = "_bt-6";
export var detailTitle = "_bt-7";
export var detailsContent = "_bt-5";
export var header = "_bt-8";
export var headerWithClose = "_bt-9";
export var icon = "_bt-a";
export var infoIcon = "_bt-c";
export var informationContainer = "_bt-b";
export var sideDrawer = "_bt-d";
export var sideDrawerOpen = "_bt-e";
export var stickyFooter = "_bt-f";
export var typeOption = "_bt-g";